import styled, { css } from 'styled-components';
import mq from '../../utils/mediaQueries.js';
import { isDefaultTheme, isGlobetrotter } from '../../utils/theming.js';

// @ts-nocheck
var heightsGlobe = {
  s: '61px',
  m: '85px',
  l: '122px'
};
var widthsGlobe = {
  s: '92px',
  m: '128px',
  l: '184px'
};
var scalesGlobe = {
  s: 0.5,
  m: 0.7,
  l: 1
};
var heights = {
  s: '32px',
  m: '48px',
  l: '64px'
};
var sizeS = css(["height:", ";padding:var(--space-100);"], heights.s);
var sizeM = css(["height:", ";padding:var(--space-200);"], heights.m);
var sizeL = css(["height:", ";padding:var(--space-200);"], heights.l);
var Background = styled.div.withConfig({
  displayName: "cruiseLogostyle__Background",
  componentId: "sc-1mscv2f-0"
})(["display:inline-flex;align-items:center;justify-content:center;background-color:var(--color-white);", " ", ""], isDefaultTheme(css(["width:auto;border-radius:var(--border-radius-300);box-shadow:var(--elevation-100);img{height:100%;}", ""], function (_ref) {
  var $size = _ref.$size,
    $responsive = _ref.$responsive;
  return css(["", " ", " ", ""], $size === 's' && css(["", ""], sizeS), $size === 'm' && css(["", " ", ""], sizeM, $responsive && css(["", ""], mq.sMax(css(["", ""], sizeS)))), $size === 'l' && css(["", " ", ""], sizeL, $responsive && css(["", " ", ""], mq.mMax(css(["", ""], sizeM)), mq.sMax(css(["", ""], sizeS)))));
})), isGlobetrotter(css(["", ""], function (_ref2) {
  var $size = _ref2.$size,
    $responsive = _ref2.$responsive;
  return css(["", " ", " ", ""], $size === 's' && css(["height:", ";width:", ";img{transform:scale(", ");}"], heightsGlobe.s, widthsGlobe.s, scalesGlobe.s), $size === 'm' && css(["height:", ";width:", ";img{transform:scale(", ");}", ""], heightsGlobe.m, widthsGlobe.m, scalesGlobe.m, $responsive && css(["", ""], mq.sMax(css(["height:", ";width:", ";img{transform:scale(", ");}"], heightsGlobe.s, widthsGlobe.s, scalesGlobe.s)))), $size === 'l' && css(["height:", ";width:", ";img{transform:scale(", ");}", ""], heightsGlobe.l, widthsGlobe.l, scalesGlobe.l, $responsive && css(["", " ", ""], mq.mMax(css(["height:", ";width:", ";img{transform:scale(", ");}"], heightsGlobe.m, widthsGlobe.m, scalesGlobe.m)), mq.sMax(css(["height:", ";width:", ";img{transform:scale(", ");}"], heightsGlobe.s, widthsGlobe.s, scalesGlobe.s)))));
})));

export { Background };
//# sourceMappingURL=cruiseLogo.style.js.map
